import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.DesertTerraform;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "DesertTerraform.Phaser.IntroductionScene.1",
            "DesertTerraform.Phaser.IntroductionScene.2",
            "DesertTerraform.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/DesertTerraformGame/scenes/GameIntro.ts